import React from "react";
import { Box, Button, Stack } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { navigationLinks } from "../../data/mockData";

const linkStyles = (active) => ({
  color: active ? "secondary.main" : "text.primary",
  fontWeight: active ? 800 : 700,
  fontSize: { md: "0.89rem", lg: "0.95rem" },
  letterSpacing: "0.02em",
  position: "relative",
  minHeight: { xs: 46, md: 42 },
  justifyContent: { xs: "flex-start", md: "center" },
  px: { xs: 1.2, md: 1.4, lg: 1.5 },
  borderRadius: 999,
  backgroundColor: active ? "rgba(183,132,69,0.12)" : "transparent",
  "&:hover": {
    backgroundColor: active ? "rgba(183,132,69,0.14)" : "rgba(15,27,45,0.05)",
  },
});

const NavMenu = ({ onNavigate }) => {
  const location = useLocation();

  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      spacing={{ xs: 0.6, md: 0.5, lg: 0.65 }}
      alignItems={{ xs: "stretch", md: "center" }}
    >
      {navigationLinks.map((item) => {
        const active =
          item.to === "/"
            ? location.pathname === item.to
            : location.pathname.startsWith(item.to);

        return (
          <Button
            key={item.to}
            component={RouterLink}
            to={item.to}
            onClick={onNavigate}
            sx={linkStyles(active)}
          >
            {item.label}
          </Button>
        );
      })}
      <Box sx={{ display: { xs: "none", lg: "block" }, ml: { lg: 0.7 } }}>
        <Button component={RouterLink} to="/contact" variant="contained" size="medium">
          Start a Conversation
        </Button>
      </Box>
    </Stack>
  );
};

export default NavMenu;
